import { config } from '../config';
import { downloadFile, makeApiRequest_AppJson, makeApiRequest_formData } from './common-apiService';

// LOGBOOKS

export const fetchAreaIndicatorLogbook = async (accessToken, areaIndicatorId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/byAreaIndicatorId/${areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchAreaLogbook = async (accessToken, areaId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/byAreaId/${areaId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchPlanLogbook = async (accessToken, planUUID) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/byPlanUUID/${planUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const createLogbook = async (accessToken, logbookDTO) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'POST', headers, logbookDTO);
}

export const changeLogbookOwner = async (accessToken, logbookId, userUUID) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/owner/${userUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'PUT', headers);
}

export const deleteLogbook = async (accessToken, logbookId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// WHITELIST

export const protectLogbook = async (accessToken, logbookId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/protect`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'PUT', headers);
}

export const unprotectLogbook = async (accessToken, logbookId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/unprotect`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'PUT', headers);
}

export const addMemberToWhitelist = async (accessToken, logbookId, userUUID) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/whitelist/${userUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'POST', headers);
}

export const removeMemberFromWhitelist = async (accessToken, logbookId, userUUID) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/whitelist/${userUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// FOLDERS

export const createFolder = async (accessToken, logbookId, folderDTO) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/newFolder`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'POST', headers, folderDTO);
}

export const updateFolder = async (accessToken, logbookId, logBookFolderId, folderDTO) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'PUT', headers, folderDTO);
}

export const deleteFolder = async (accessToken, logbookId, logBookFolderId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const getFolder = async (accessToken, logbookId, logBookFolderId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'GET', headers);
}

// ITEMS

export const createItem = async (accessToken, logbookId, logBookFolderId = 0, itemDTO, file = null) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}/newItem`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('newLogBookItemDTO', JSON.stringify(itemDTO));
        return makeApiRequest_formData(url, 'POST', headers, formData);
    } else {
        const formData = new FormData();
        formData.append('newLogBookItemDTO', JSON.stringify(itemDTO));
        return makeApiRequest_formData(url, 'POST', headers, formData);
    }
}

export const updateItem = async (accessToken, logbookId, logBookFolderId, logBookItemId, itemDTO, file = null) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}/${logBookItemId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('newLogBookItemDTO', JSON.stringify(itemDTO));
        return makeApiRequest_formData(url, 'PUT', headers, formData);
    } else {
        const formData = new FormData();
        formData.append('newLogBookItemDTO', JSON.stringify(itemDTO));
        return makeApiRequest_formData(url, 'PUT', headers, formData);
    }
}

export const deleteItem = async (accessToken, logbookId, logBookFolderId, logBookItemId) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}/${logBookItemId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const downloadFileRelatedToItem = async (accessToken, logbookId, logBookFolderId, logBookItemId, fileName) => {
    const url = `${config.baseB2B_URL}/b2b/logbook/${logbookId}/${logBookFolderId}/${logBookItemId}/download`;
    return downloadFile(accessToken, url, fileName);
}

// GIT

export const fetchGitLogbookData = async () => {
    const url = `${config.baseB2B_URL}/b2b/logbook/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};